import React, { useContext } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Login, VerifyUser, Maintenance, ContactUs } from '../../Main';
import { RequestResetPassword } from '../../RequestResetPassword';
import { EmailSent } from '../../EmailSent';
import { ResetPassword } from '../../ResetPassword';
import { AuthContext } from '../store';
import { SERVICE_STATE } from '../consts';
import { UserInvite } from '../../Main/UserInvite/UserInvite';

const Routes = () => {
    const { serviceState } = useContext(AuthContext);

    if (serviceState !== SERVICE_STATE.OK) {
        return (
            <Switch>
                <Route path="/" component={Maintenance} />
                <Redirect from="*" to="/" />
            </Switch>
        );
    } else {
        return (
            <Switch>
                <Route path="/main" component={Maintenance} />
                <Route path="/login" component={Login} />
                <Route path="/contact_us" component={ContactUs} />
                <Route path="/request_password_reset" component={RequestResetPassword} />
                <Route path="/email_sent" component={EmailSent} />
                <Route path="/reset_password/:token" component={ResetPassword} />
                <Route path="/user_invite/:email/:token" component={UserInvite} />
                <Route path="/verify/:token" component={VerifyUser} />
                <Redirect from="/" to="/login" exact />
            </Switch>
        );
    }
};

export default Routes;
